/**
 * The hosted trigger form a workflow's end users open in their own tab. The
 * route pattern lives here so the router, the copied URL and the form page all
 * derive the path from one place.
 */
export const TRIGGER_FORM_ROUTE_SEGMENT = 'form-trigger-url';

export const TRIGGER_FORM_ROUTE = `/workflows/${TRIGGER_FORM_ROUTE_SEGMENT}/:workflowId`;

export function buildTriggerFormPath(workflowId: number | string): string {
  return `/workflows/${TRIGGER_FORM_ROUTE_SEGMENT}/${workflowId}`;
}

/** Absolute URL for sharing — what `Copy URL` puts on the clipboard. */
export function buildTriggerFormUrl(workflowId: number | string): string {
  return `${window.location.origin}${buildTriggerFormPath(workflowId)}`;
}

/**
 * Whether a form trigger has anything to hand out: an unconfigured trigger
 * node carries no fields, so its URL would open a form nobody can fill.
 */
export function hasShareableFormFields(
  config: Record<string, unknown> | undefined
): boolean {
  const fields = config?.fields;
  return (
    Array.isArray(fields) &&
    fields.some(
      (field) =>
        field !== null &&
        typeof field === 'object' &&
        !Array.isArray(field) &&
        typeof (field as Record<string, unknown>).name === 'string' &&
        (field as Record<string, unknown>).name !== ''
    )
  );
}
